import React from 'react';
import { cn } from '../../../utils/cn';
import './Button.scss';

/**
 * Button component with multiple variants and sizes
 */

const Button = React.forwardRef(
  (
    { className, variant = 'default', size = 'md', children, disabled = false, type = 'button', onClick, ...props },
    ref,
  ) => {
    const variantClass = `button-ui--${variant}`;
    const sizeClass = `button-ui--${size}`;

    return (
      <button
        ref={ref}
        type={type}
        className={cn('button-ui', variantClass, sizeClass, className)}
        disabled={disabled}
        onClick={onClick}
        {...props}
      >
        {children}
      </button>
    );
  },
);

Button.displayName = 'Button';

export default Button;
